import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { carouselData } from '../components/data';
import './hospitalSlideshow.css';

const responsive = {
  desktop: { breakpoint: { max: 10000, min: 1024 }, items: 1 },
  tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
};

export default function Carousel2() {
  return (
    <section id="hospital-slideshow" className="hospital-slideshow" aria-label="Hospital photographs">
      <div className="hospital-slideshow__container">
        <div className="hospital-slideshow__track">
          <Carousel responsive={responsive} showDots renderDotsOutside keyboardControl>
            {carouselData.map((photo, index) => (
              <div key={photo.id} className="hospital-slideshow__slide">
                <img
                  src={photo.img}
                  alt={photo.alt}
                  width={photo.width}
                  height={photo.height}
                  loading={index === 0 ? 'eager' : 'lazy'}
                  decoding="async"
                />
              </div>
            ))}
          </Carousel>
        </div>
        <a href="#hospital-gallery" className="hospital-slideshow__gallery-link">
          View hospital gallery
        </a>
      </div>
    </section>
  );
}
